"use client";

import { useIsomorphicLayoutEffect } from "@/lib/hooks/useIsomorphicLayoutEffect";
import { useRouter } from "next/navigation";

type Props = {
  href: string;
  replace?: boolean;
};

export const Redirect = ({ href, replace }: Props) => {
  const router = useRouter();
  useIsomorphicLayoutEffect(() => {
    const push = replace ? router.replace : router.push;
    push(href);
  }, [href, replace]);
  return null;
};
